module.exports = __webpack_public_path__ + "img/upper pocket buttons quantity.2379ba81.png";